import * as React from 'react';
import css from './NumberedSnippet.scss';
import type { AppDetails } from '../../types';

interface SelfHostedAppCodeProps extends AppDetails {}

const SelfHostedAppCodeBase = {
  firstComment:
    "# App ID and App Secret Key: Retrieve from the OAuth page in the app's dashboard in the Wix Dev Center.",
  secondComment:
    "# App JWT (Public) Key: Retrieve from the Webhooks page in the app's dashboard in the Wix Dev Center.",
  appSecretKey: 'WIX_APP_SECRET',
  jwtKey: 'WIX_APP_JWT_KEY',
  appIdKey: 'WIX_APP_ID',
};
export const getSelfHostedAppText = ({
  appSecret,
  appId,
  appPublicKey,
}: SelfHostedAppCodeProps) => `
${SelfHostedAppCodeBase.firstComment}    
${SelfHostedAppCodeBase.appSecretKey}=${appSecret}
${SelfHostedAppCodeBase.appIdKey}=${appId}\n
${SelfHostedAppCodeBase.secondComment}
${SelfHostedAppCodeBase.jwtKey}=${appPublicKey}
`;

export const SelfHostedAppCode: React.FC<SelfHostedAppCodeProps> = ({
  appSecret,
  appId,
  appPublicKey,
}) => {
  return (
    <span className={css.selfHostedAppCode}>
      <span className={css.comment}>{SelfHostedAppCodeBase.firstComment}</span>
      <br />
      <span className={css.key}>{SelfHostedAppCodeBase.appSecretKey}</span>
      <span className={css.equal}> = </span>
      <span className={css.value}>{appSecret}</span>
      <br />
      <span className={css.key}>{SelfHostedAppCodeBase.appIdKey}</span>
      <span className={css.equal}> = </span>
      <span className={css.value}>{appId}</span>
      <br />
      <br />
      <span className={css.comment}>{SelfHostedAppCodeBase.secondComment}</span>
      <br />
      <span className={css.noWrap}>
        <span className={css.key}>{SelfHostedAppCodeBase.jwtKey}</span>
        <span className={css.equal}> = </span>
        <span className={css.value}>{appPublicKey}</span>
      </span>
    </span>
  );
};
